import { render, staticRenderFns } from "./routerAndPrint.vue?vue&type=template&id=a71dcc20&"
import script from "./routerAndPrint.vue?vue&type=script&lang=js&"
export * from "./routerAndPrint.vue?vue&type=script&lang=js&"
import style0 from "./routerAndPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a71dcc20')) {
      api.createRecord('a71dcc20', component.options)
    } else {
      api.reload('a71dcc20', component.options)
    }
    module.hot.accept("./routerAndPrint.vue?vue&type=template&id=a71dcc20&", function () {
      api.rerender('a71dcc20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/routerAndPrint.vue"
export default component.exports